async function authenticate (reqBody) {
  const res = await fetch('/api/auth', {
    method: 'POST',
    body: JSON.stringify(reqBody),
    headers: {
      'Content-Type': 'application/json'
    }
  })

  console.log(res)
  // console.log(res.json())
  return res.json()
}

async function authenticateWithRedirect (reqBody) {
  const res = await fetch('/api/authV2', {
    method: 'POST',
    body: JSON.stringify(reqBody),
    headers: {
      'Content-Type': 'application/json'
    }
  })
  return res.json();
}

async function submitMoreInfos (reqBody) {
  const res = await fetch('/api/auth/moreinfo', {
    method: 'POST',
    body: JSON.stringify(reqBody),
    headers: { 'Content-Type': 'application/json' }
  })
  return res.json()
}

async function containerEnquiry (reqBody) {
  const res = await fetch('/api/container-enquiry', {
    method: 'POST',
    body: JSON.stringify(reqBody),
    headers: { 'Content-Type': 'application/json', user: 'DCSV' }
  })
  return res.json()
}

async function deliveryBooking (reqBody) {
  const res = await fetch('/api/delivery-booking', {
    method: 'POST',
    body: JSON.stringify(reqBody),
    headers: { 'Content-Type': 'application/json', user: 'DCSV' }
  })
  return res.json()
}

async function pinReleaseRequest (reqBody) {
  const res = await fetch('/api/pin-request', {
    method: 'POST',
    body: JSON.stringify(reqBody),
    headers: { 'Content-Type': 'application/json', user: 'DCSV' }
  })
  return res.json()
}

async function rtoInstruction (reqBody) {
  const res = await fetch('/api/rto-instruction', {
    method: 'POST',
    body: JSON.stringify(reqBody),
    headers: { 'Content-Type': 'application/json', user: 'DCSV' }
  })
  return res.json()
}

async function rtoInstEmailConfirmApi (reqBody) {
  const res = await fetch('/api/rtoInstEmailConfirm', {
    method: 'POST',
    body: JSON.stringify(reqBody),
    headers: { 'Content-Type': 'application/json', user: 'DCSV' }
  })
  return res.json()
}

async function deliveryBookingEmailConfirmApi (reqBody) {
  const res = await fetch('/api/deliveryBookingEmailConfirm', {
    method: 'POST',
    body: JSON.stringify(reqBody),
    headers: { 'Content-Type': 'application/json', user: 'DCSV' }
  })
  return res.json()
}

async function customsBrokerage (reqBody) {
  const res = await fetch('/api/customs-brokerage', {
    method: 'POST',
    body: JSON.stringify(reqBody),
    headers: { 'Content-Type': 'application/json', user: 'DCSV' }
  })
  return res.json()
}

async function submitMoreInfosV2 (reqBody) {
  const res = await fetch('/api/authV2/moreinfo', {
    method: 'POST',
    body: JSON.stringify(reqBody),
    headers: { 'Content-Type': 'application/json' }
  })
  return res.json()
}

async function rtoInstEmailConfirmApiV2 (reqBody) {
  const res = await fetch('/api/rtoInstEmailConfirmV2', {
    method: 'POST',
    body: JSON.stringify(reqBody),
    headers: { 'Content-Type': 'application/json', user: 'DCSV' }
  })
  return res.json()
}

async function deliveryBookingEmailConfirmApiV2 (reqBody) {
  const res = await fetch('/api/deliveryBookingEmailConfirmV2', {
    method: 'POST',
    body: JSON.stringify(reqBody),
    headers: { 'Content-Type': 'application/json', user: 'DCSV' }
  })
  return res.json()
}

async function testMail(reqBody){
  const res = await fetch('/api/testMail', {
    method: 'POST',
    body: JSON.stringify(reqBody),
    headers: { 'Content-Type': 'application/json', user: 'DCSV', 'x-requested-with': 'XMLHttpRequest' } 
  })
  await errorHandler(res)
  return res.status == 200;
}

export {
  authenticate,
  submitMoreInfos,
  containerEnquiry,
  deliveryBooking,
  pinReleaseRequest,
  rtoInstruction,
  rtoInstEmailConfirmApi,
  deliveryBookingEmailConfirmApi,
  customsBrokerage,
  authenticateWithRedirect,
  submitMoreInfosV2,
  rtoInstEmailConfirmApiV2,
  deliveryBookingEmailConfirmApiV2,
  testMail
}
